import { Box, Stack, Text, useTheme } from '@ltvco/refresh-lib/theme';
import { formatPhone, unformatPhone } from '@ltvco/refresh-lib/utils';

import { ReportChip } from 'components/ChatBV/components';
import { PossibleReportParams } from 'components/ChatBV/types';

interface ReportSelectionPillsProps {
  possibleReports: PossibleReportParams[];
  onReportSelected: (report: PossibleReportParams) => void;
}

export const ReportSelectionPills = ({
  possibleReports,
  onReportSelected,
}: ReportSelectionPillsProps) => {
  const theme = useTheme();

  const handleChipClick = (report: PossibleReportParams) => {
    const reportToSend = { ...report };
    if (report.search_type === 'phone' && report.phone_number) {
      const cleanPhone = unformatPhone(report.phone_number);
      const phoneDigits =
        cleanPhone.length === 11 && cleanPhone.startsWith('1')
          ? cleanPhone.substring(1)
          : cleanPhone;
      reportToSend.phone_number = formatPhone(phoneDigits);
    }
    onReportSelected(reportToSend);
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Text
        variant="body1"
        sx={{
          color: theme.palette.text.primary,
          marginBottom: 2,
        }}
      >
        I found multiple ways to search using this image.
      </Text>
      <Text
        variant="body1"
        sx={{
          color: theme.palette.text.primary,
          marginBottom: 2,
        }}
      >
        You can continue with a:
      </Text>
      <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
        {possibleReports.map((report, index) => (
          <ReportChip
            key={index}
            report={report}
            onChipClick={handleChipClick}
          />
        ))}
      </Stack>
      <Text
        variant="body1"
        sx={{
          color: theme.palette.text.primary,
          marginTop: 2,
        }}
      >
        Just click the option that fits what you're looking for.
      </Text>
    </Box>
  );
};
